import styled from "styled-components"

export const DividerRootContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DividerStyled = styled.span`
  ::before {
    content: '|';
    color: ${({ theme }) => theme.old.colors.gray[400]};
    font-size: ${({ theme }) => theme.old.fonts.size.normal};
    font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
    line-height: 20px;
  }
`

export const DividerChildContainer = styled.span`
  color: ${({ theme }) => theme.old.colors.white};
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
  line-height: 20px;
`